export default __webpack_public_path__ + "static/Badges2-66597cb9d3cd51b3c7ec2cc3da89175d.svg";